'use strict';

/* globals window, $ */

var EventEmitter = require('events').EventEmitter;

var _ = require('lodash');

var at = require('../utils/environment');
var PostArticle = require('../items/post-article.jsx');
var PostVideo = require('../items/post-video.jsx');
var recommendationAdapter = require('./adapters/recommendation');
var falkorAdapter = require('./adapters/falkor');

var FACTORIES = {
    'materia': PostArticle,
    'materia-video': PostArticle,
    'video': PostVideo
};


var PostStore = function(config) {
    this._posts = [];
    this._feedId = config.feedId;

    this.ifIsDuplicated = _.bind(this.ifIsDuplicated, this);

    if (_.isArray(config.posts)) {
        this._posts.push.apply(this._posts, config.posts);
        if (at.client) this.removeDuplicatedPosts(this._posts);
        this.assignFactories(this._posts);
    }

    if (_.isNumber(config.nextPage)) this._nextPage = config.nextPage;
    if (_.isNumber(config.min)) this._min = config.min;
    if (at.client) {
        this.request = _.throttle(this.request, 500);
        this.isAutoLoadMoreActive = config.isAutoLoadMoreActive;
    }

    if (config.isRecommended) {
        this._isRecommended = true;
        this._recommendationUrl = config.recommendationUrl;
    }
};

PostStore.prototype = {
    'name': 'PostStore',
    _feedId: null,
    _nextPage: null,
    _hasNextPage: true,
    _limit: 10,
    _min: 20,
    _isLoading: false,
    _requestURL: null,
    _knowPosts: [],
    _isFirstPage: true,
    _pickFailed: false,

    getNextDataPageNumber: function() {
        if (this._nextPage === null)
            return Math.floor(this._posts.length / this._limit) + 1;
        else {
            this.getNextDataPageNumber = _.bind(function() {
                return this._nextPage;
            }, this);
            return this.getNextDataPageNumber();
        }
    },

    isEmpty: function() {
        return (this._posts.length === 0);
    },

    pick: function() {
        try {
            var doesItExist = this._posts[0].length;
            doesItExist = undefined;

            return this._posts.shift();
        } catch(err) {
            this._pickFailed = true;
        } finally {
            if (at.client && this.shouldCallRequest()) {
                this.request();
            }
        }
    },

    shouldCallRequest: function() {
        var hasFewPages;

        if (this._isRecommended) {
            if (this.isAutoLoadMoreActive() === false || this._pickFailed) {
                hasFewPages = Boolean(this._posts.length === 0);
                this._pickFailed = false;
            }
        } else {
            hasFewPages = Boolean(this._posts.length < this._min);
        }

        if (this._isFirstPage || (this._hasNextPage && hasFewPages)) {
            return true;
        }
        return false;
    },

    request: function() {
        this._isFirstPage = false;

        if (this._isLoading || !window.$) return;

        this._isLoading = true;

        var request;
        if (this._isRecommended) {
            request = this.requestRecommendation();
            $.when(request).fail(_.bind(function() {
                this._isRecommended = false;
            }, this));
        }
        else request = this.requestFalkor();

        $.when(request).done(_.bind(this.handleReceivedPosts, this));
        $.when(request).always(_.bind(function() {
            this._isLoading = false;
        }, this));
    },

    handleReceivedPosts: function(data) {
        var posts;
        var wasEmpty = this.isEmpty();

        if (data.tag) {
            if (recommendationAdapter.getCurrentPage() === 1)
                this.replaceFallback([]);
            return this.callFallback(data.tag);
        }

        if (data.nextPage) this._nextPage = data.nextPage;

        if (this._isRecommended) {
            posts = recommendationAdapter.handleReceivedPosts(data, this);

            if (recommendationAdapter.getCurrentPage() === 1)
                return this.replaceFallback(posts);

        } else {
            data.items = this.removeDuplicatedPosts(data.items);
            this.assignFactories(data.items);
            posts = falkorAdapter.handleReceivedPosts(data, this);
        }

        this._posts.push.apply(this._posts, posts);

        if (wasEmpty && this.isEmpty() === false) {
            _.defer(_.bind(this.emit, this, 'restocked'));
        }
    },

    requestRecommendation: function() {
        return recommendationAdapter.request({
                recommendationUrl: this._recommendationUrl
            });
    },

    requestFalkor: function() {
        try {
            var config = {
                feedId: this._feedId,
                page: this.getNextDataPageNumber()
            };
            if (window.SETTINGS.FALKOR_URL ||
                window.SETTINGS.BASTIAN.FALKOR_URL) {
                config.falkorUrl = (
                    window.SETTINGS.FALKOR_URL ||
                    window.SETTINGS.BASTIAN.FALKOR_URL
                );
            } else throw new ReferenceError('FALKOR_URL is not defined');
            if (window.SETTINGS.BASTIAN.QUERY_PARAMETER) {
                config.query_parameter = window.SETTINGS.BASTIAN.QUERY_PARAMETER;
            }
        } catch(e) {
            console.warn('Soft error: not able to prepare a request to falkor');
            console.error(e);
            return window.$.Deferred();
        }
        return falkorAdapter.request(config);
    },

    callFallback: function(tag) {
        if (this.tag === undefined)
            this.prepareFirstPageToReceiveTag();

        this.tag = tag;
        this._isRecommended = false;
        this.request();
        return;
    },

    replaceFallback: function(posts) {
        this._posts = [];
        this._posts.push.apply(this._posts, posts);
        this.emit('remove-posts');
    },

    prepareFirstPageToReceiveTag: function() {
        this._knowPosts = [];
        this._nextPage = 1;
    },

    removeDuplicatedPosts: function(items) {
        items = _.reject(items, this.ifIsDuplicated);
        var ids = [];
        for (var item in items) ids.push(items[item].id);
        this._knowPosts.push.apply(this._knowPosts, ids);
        return items;
    },

    ifIsDuplicated: function(item) {
        return _.includes(this._knowPosts, item.id);
    },

    assignFactories: function(items) {
        var iterations = items.length;
        var item;

        while (iterations--) {
            item = items[iterations];
            item.klass = (FACTORIES[item.type] || PostArticle);
        }
    }
};

_.extend(PostStore.prototype, EventEmitter.prototype);

module.exports = PostStore;
